import React, { use, useEffect, useRef } from "react";

import { useNavigate } from "react-router-dom";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import CurtainsClosedOutlinedIcon from "@mui/icons-material/CurtainsClosedOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import { useState } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "../../../Helper/cropImage";
import ReactCountryFlag from "react-country-flag";
import { showToast } from "../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { hitSendEmailVerificationCode } from "../../../Redux/Common/EmailSendVerificationCodeSlice";
import { hitVerifyEmailVerificationCode } from "../../../Redux/Common/EmailVerifyCodeSlice";
import { hitCreateProfileApi } from "../../../Redux/Professional/CreateProfileSlice";
import { hitGetProfileApi } from "../../../Redux/Professional/GetProfileSlice";
import { hitUploadMedia } from "../../../Redux/Common/UploadMediaSlice";
import CompanyLogo from "../../../assets/img/company logo.svg";
import add_company_logo from "../../../assets/img/add company kogo.svg";
import { hitGetStartVerificationVeriff } from "../../../Redux/Common/CreateVeriffVerificationSlice";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import External from "../../../assets/svg/External";
import Loader from "../../Loader/Loader"; // adjust the path
import { set } from "date-fns";
import TabletMacOutlinedIcon from "@mui/icons-material/TabletMacOutlined";
import Identityverification from "../../../assets/img/Identity verification 1.svg";
import IDVerificationProgress from "../../../assets/img/ID Verification In Progress.svg";
import VerificationFailed from "../../../assets/img/Verification Failed.svg";
import RetryVerification from "../../../assets/img/Retry Verification.svg";
import charm_circle_tick from "../../../assets/img/charm_circle-tick.svg";
import charm_circle_tick_Verify_Email from "../../../assets/img/charm_circle-tick Verify Email.svg";

const countries = [
  { code: "+1", country: "US", flag: "🇺🇸", name: "United States" },
  { code: "+1", country: "CA", flag: "🇨🇦", name: "Canada" },
  { code: "+44", country: "GB", flag: "🇬🇧", name: "United Kingdom" },
  { code: "+91", country: "IN", flag: "🇮🇳", name: "India" },
  { code: "+86", country: "CN", flag: "🇨🇳", name: "China" },
  { code: "+81", country: "JP", flag: "🇯🇵", name: "Japan" },
  { code: "+49", country: "DE", flag: "🇩🇪", name: "Germany" },
  { code: "+33", country: "FR", flag: "🇫🇷", name: "France" },
  { code: "+39", country: "IT", flag: "🇮🇹", name: "Italy" },
  { code: "+34", country: "ES", flag: "🇪🇸", name: "Spain" },
  { code: "+61", country: "AU", flag: "🇦🇺", name: "Australia" },
  { code: "+7", country: "RU", flag: "🇷🇺", name: "Russia" },
  { code: "+55", country: "BR", flag: "🇧🇷", name: "Brazil" },
  { code: "+52", country: "MX", flag: "🇲🇽", name: "Mexico" },
  { code: "+82", country: "KR", flag: "🇰🇷", name: "South Korea" },
  { code: "+31", country: "NL", flag: "🇳🇱", name: "Netherlands" },
  { code: "+46", country: "SE", flag: "🇸🇪", name: "Sweden" },
  { code: "+47", country: "NO", flag: "🇳🇴", name: "Norway" },
  { code: "+45", country: "DK", flag: "🇩🇰", name: "Denmark" },
  { code: "+358", country: "FI", flag: "🇫🇮", name: "Finland" },
  { code: "+48", country: "PL", flag: "🇵🇱", name: "Poland" },
  { code: "+41", country: "CH", flag: "🇨🇭", name: "Switzerland" },
  { code: "+43", country: "AT", flag: "🇦🇹", name: "Austria" },
  { code: "+32", country: "BE", flag: "🇧🇪", name: "Belgium" },
  { code: "+351", country: "PT", flag: "🇵🇹", name: "Portugal" },
  { code: "+30", country: "GR", flag: "🇬🇷", name: "Greece" },
  { code: "+420", country: "CZ", flag: "🇨🇿", name: "Czech Republic" },
  { code: "+36", country: "HU", flag: "🇭🇺", name: "Hungary" },
  { code: "+40", country: "RO", flag: "🇷🇴", name: "Romania" },
  { code: "+64", country: "NZ", flag: "🇳🇿", name: "New Zealand" },
  { code: "+65", country: "SG", flag: "🇸🇬", name: "Singapore" },
  { code: "+60", country: "MY", flag: "🇲🇾", name: "Malaysia" },
  { code: "+66", country: "TH", flag: "🇹🇭", name: "Thailand" },
  { code: "+63", country: "PH", flag: "🇵🇭", name: "Philippines" },
  { code: "+62", country: "ID", flag: "🇮🇩", name: "Indonesia" },
  { code: "+84", country: "VN", flag: "🇻🇳", name: "Vietnam" },
  { code: "+27", country: "ZA", flag: "🇿🇦", name: "South Africa" },
  { code: "+20", country: "EG", flag: "🇪🇬", name: "Egypt" },
  { code: "+234", country: "NG", flag: "🇳🇬", name: "Nigeria" },
  { code: "+254", country: "KE", flag: "🇰🇪", name: "Kenya" },
  { code: "+971", country: "AE", flag: "🇦🇪", name: "UAE" },
  { code: "+966", country: "SA", flag: "🇸🇦", name: "Saudi Arabia" },
  { code: "+972", country: "IL", flag: "🇮🇱", name: "Israel" },
  { code: "+90", country: "TR", flag: "🇹🇷", name: "Turkey" },
  { code: "+54", country: "AR", flag: "🇦🇷", name: "Argentina" },
  { code: "+56", country: "CL", flag: "🇨🇱", name: "Chile" },
  { code: "+57", country: "CO", flag: "🇨🇴", name: "Colombia" },
  { code: "+51", country: "PE", flag: "🇵🇪", name: "Peru" },
];

const SignUpStepOne = () => {
  const [selected, setSelected] = useState(countries[0]);
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  const filteredCountries = countries.filter(
    (country) =>
      country.name.toLowerCase().includes(search.toLowerCase()) ||
      country.code.includes(search) ||
      country.country.toLowerCase().includes(search.toLowerCase()),
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearch("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);



  const handleSelect = (country) => {
    setSelected(country);
    setFormData((prev) => ({
      ...prev,
      countryCode: country.code,
    }));
    setIsOpen(false);
    setSearch("");
  };

  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [verificationCode, setVerificationCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [companyLogo, setCompanyLogo] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [showCropper, setShowCropper] = useState(false);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [aspect, setAspect] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [flip, setFlip] = useState({ horizontal: false, vertical: false });
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [professionalData, setProfessionalData] = useState(null);
  const [showVerificationInput, setShowVerificationInput] = useState(false);
  const [showSendVerificationButton, setShowSendVerificationButton] =
    useState(true);
  const [emailVerified, setEmailVerified] = useState(false);
  const [showVerifyEmailButton, setShowVerifyEmailButton] = useState(false);
  const [file, setFile] = useState(null);

  const [formData, setFormData] = useState({
    companyName: "",
    firstName: "",
    lastName: "",
    companyFoundedDate: "",
    companySize: "Small Team (1-9 employees)",
    email: "",
    mobileNumber: "",
    countryCode: "",
    profileSteps: 0,
  });

  useEffect(() => {
    const storedData = localStorage.getItem("professionalData");
    localStorage.removeItem("clientData");
    localStorage.removeItem("clientToken");
    localStorage.removeItem("clientId");
    if (storedData) {
      fetchProfessionalData();
    }
  }, []);

  const fetchProfessionalData = async () => {
    try {
      const response = await dispatch(hitGetProfileApi());
      setProfessionalData(response.payload.data);
    } catch (error) {
      console.error("Error fetching professional data:", error);
    }
  };

  useEffect(() => {
    if (professionalData) {
      setFormData((prev) => ({
        ...prev,
        companyName: professionalData.companyName || "",
        firstName: professionalData.firstName || "",
        lastName: professionalData.lastName || "",
        companyFoundedDate: professionalData.companyFoundedDate || "",
        companySize:
          professionalData.companySize || "Small Team (1-9 employees)",
        email: professionalData.email || "",
        mobileNumber: professionalData.mobileNumber || "",
        countryCode: professionalData.countryCode || "",
        profileSteps: professionalData.profileSteps || 0,
        companyLogo: professionalData.companyLogo || "",
        profileImage: professionalData.profileImage || "",
      }));
      setCompanyLogo(professionalData.companyLogo);
      if (professionalData.isEmailVerified == 1) {
        setEmailVerified(true);
        setShowSendVerificationButton(false);
        setShowVerificationInput(false);
        setShowVerifyEmailButton(false);
      }
    }
  }, [professionalData]);

  // Handle file selection
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const previewUrl = URL.createObjectURL(selectedFile);
      setImageUrl(previewUrl);
      setShowCropper(true);
      setFile(selectedFile);
    }
  };

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const handleCropSave = async () => {
    try {
      const croppedImage = await getCroppedImg(imageUrl, croppedAreaPixels);
      setShowCropper(false);
      setImageUrl(croppedImage);
      // Convert base64 to File for upload
      const res = await fetch(croppedImage);
      const blob = await res.blob();
      const croppedFile = new File([blob], file.name, { type: file.type });
      setFile(croppedFile);
    } catch (e) {
      showToast("Failed to crop image", "error");
      setShowCropper(false);
    }
  };

  // UseEffect to trigger upload when `file` changes
  useEffect(() => {
    if (file && !showCropper) {
      uploadFile();
    }
  }, [file, showCropper]);

  // Function to handle file upload
  const uploadFile = async () => {
    //console.log("upload file calling");
    setLoading(true);
    if (file) {
      //console.log("myfile", file);
      const formData = new FormData();
      formData.append("myfile", file);
      try {
        const response = await dispatch(hitUploadMedia(formData));
        setLoading(false);
        if (response.payload.status === true) {
          setCompanyLogo(response.payload.data[0].url);
        } else {
          setLoading(false);
          showToast(response.payload.message, "error");
        }
      } catch (error) {
        setLoading(false);
        console.error("File upload error:", error);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Check if all required fields are filled
  const isFormValid =
    (formData.firstName || "").trim() &&
    (formData.lastName || "").trim() &&
    (formData.dateOfBirth || "").trim() &&
    // (formData.city || "").trim() &&
    // (formData.state || "").trim() &&
    // (formData.country || "").trim() &&
    //formData.countryCode &&
    // formData.latitude &&
    // (formData.address || "").trim() &&
    // formData.longitude &&
    formData.mobileNumber;

  const startVerification = async () => {
    //console.log("startVerification calling");
    if (!formData.firstName || !formData.lastName) {
      showToast(
        "Please enter first name and last name before starting verification",
        "error",
      );
      return;
    }

    const response = await dispatch(
      hitGetStartVerificationVeriff({
        firstName: formData.firstName,
        lastName: formData.lastName,
        //email: clientData.email,
        type: 1, // 1 for professional
      }),
    );

    if (response.payload.status === "success") {
      window.open(response.payload.verification.url, "_blank");
    } else {
      showToast("Failed to start verification. Please try again.", "error");
    }
  };

  const submitFirstStep = async (e) => {
    e.preventDefault(); // 👈 stop page refresh
    try {
      setLoading(true);

      if (companyLogo) {
        formData.companyLogo = companyLogo;
        formData.profileImage = companyLogo;
      }

      formData.countryCode = selected.code;
      if (
        !formData.companyName ||
        !formData.firstName ||
        !formData.lastName ||
        !formData.companySize ||
        !formData.companyLogo
      ) {
        setLoading(false);
        showToast("Please fill all required fields", "error");
        return;
      }

      if (formData.mobileNumber === "0000000000") {
        setLoading(false);
        showToast("Invalid Phone Number", "error");
        return;
      }
      formData.profileSteps = 1;

      const response = await dispatch(hitCreateProfileApi(formData));
      setLoading(false);
      if (response.payload.status === true) {
        navigation("/professional/signup-two");
      } else {
        showToast(response.payload.message, "error");
      }
    } catch (error) {
      console.error("Error sending verification code:", error);
    }
  };

  const verifyCode = () => {
    // Logic to verify the code
    if (!verificationCode) {
      showToast("Please enter the verification code", "error");
      return;
    }
    callVerifyCodeApi(formData.email);
  };

  const callVerifyCodeApi = async (email) => {
    try {
      // Call your API to verify the code here
      setLoading(true);
      const response = await dispatch(
        hitVerifyEmailVerificationCode({
          email,
          otp: verificationCode,
          type: 1,
        }),
      );
      setLoading(false);
      if (response.payload.status === true) {
        showToast(response.payload.message, "success");
        setShowVerificationInput(false);
        setShowSendVerificationButton(false);
        setShowVerifyEmailButton(false);
        setEmailVerified(true);
      } else {
        showToast(response.payload.message, "error");
      }
    } catch (error) {
      console.error("Error verifying code:", error);
    }
  };

  if (loading) {
    return (
      <div style={{ height: "100vh" }}>
        <Loader />
      </div>
    );
  }

  // Cropper modal
  if (showCropper) {
    return (
      <div className="cropper-modal">
        <div className="cropper-container">
          <div className="cropper-area">
            <Cropper
              image={imageUrl}
              crop={crop}
              zoom={zoom}
              aspect={aspect}
              rotation={rotation}
              flip={flip}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onRotationChange={setRotation}
              onCropComplete={onCropComplete}
            />
          </div>
          <div style={{ marginTop: 16 }}>
            <label>Zoom</label>
            <input
              type="range"
              min={1}
              max={3}
              step={0.01}
              value={zoom}
              onChange={e => setZoom(Number(e.target.value))}
              style={{ width: 220 }}
            />
          </div>
          <div style={{ marginTop: 8 }}>
            <label>Rotation</label>
            <input
              type="range"
              min={0}
              max={360}
              step={1}
              value={rotation}
              onChange={e => setRotation(Number(e.target.value))}
              style={{ width: 220 }}
            />
          </div>
          <div style={{ marginTop: 8, display: 'flex', gap: 8 }}>
            {/* <button type="button" onClick={() => setFlip(f => ({ ...f, horizontal: !f.horizontal }))}>
              Flip H
            </button>
            <button type="button" onClick={() => setFlip(f => ({ ...f, vertical: !f.vertical }))}>
              Flip V
            </button> */}
            {/* <select value={aspect} onChange={e => setAspect(Number(e.target.value))}>
              <option value={1}>1:1</option>
              <option value={4/3}>4:3</option>
              <option value={16/9}>16:9</option>
              <option value={3/4}>3:4</option>
              <option value={9/16}>9:16</option>
              <option value={0}>Free</option>
            </select> */}
          </div>
          <div className="cropper-actions">
            <button className="cancel-btn" onClick={() => setShowCropper(false)}>
              Cancel
            </button>
            <button className="save-btn" onClick={handleCropSave}>
              Crop & Save
            </button>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="custom_container mb-5 pro-signup-page">
      <div className="company-form">
        {/* Header */}
        <div
          className="bussiness-form-header-top"
          style={{ background: "#f1f7fd" }}
        >
          <div className="business-form__header">
            <div
              className="business-form__step"
              style={{ alignItems: "center" }}
            >
              <span
                className="business-form__step-badge"
                style={{
                  background:
                    "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
                }}
              >
                1
              </span>
              <div>
                <span className="title_head" style={{ color: "#cc4645" }}>
                  Company Info
                </span>
              </div>
            </div>
            <p className="business-form__exit">1/4</p>
          </div>
          <div
            className="progress-bar-container"
            style={{ background: "#edf0f3" }}
          >
            <div
              className="progress-bar-fill"
              style={{
                width: "25%",
                background: "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
              }}
            ></div>
          </div>
          <p
            className="business-form__step__number mb-0"
            style={{
              background: "#fff",
              color: "#6a7280",
              fontWeight: "500",
              padding: "6px 12px",
              marginTop: 10,
            }}
          >
            Step 1 of 4
          </p>
        </div>

        {/* Title */}
        <div className="company-form__title">
          <div className="company_info">
            <p>
              <CurtainsClosedOutlinedIcon />
              <span>Company Information</span>
            </p>
          </div>
          <h2>Tell us about your company</h2>
          <p>We’ll help you create a standout company profile</p>
        </div>

        {/* Upload Logo */}

        <div className="company-form__logo-upload">
          <div className="company-form__logo-circle">
            {/* <span>Company Logo</span> */}

            <div style={{ position: "relative", display: "inline-block" }}>
              {!companyLogo ? (
                <img
                  src={CompanyLogo}
                  alt="Default Logo"
                  style={{ width: "90px", height: "90px", objectFit: "cover" }}
                />
              ) : (
                <img
                  src={companyLogo}
                  alt="Uploaded Photo"
                  style={{
                    width: "90px",
                    height: "90px",
                    objectFit: "cover",
                    borderRadius: "50%",
                    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                  }}
                />
              )}

              <img
                src={add_company_logo}
                alt="Add Logo"
                className="add_company_logo"
                style={{
                  objectFit: "cover",
                  cursor: "pointer",
                  position: "absolute",
                  bottom: "-8px",
                  right: "-2px",
                }}
                onClick={() => document.getElementById("file-input").click()}
              />
            </div>

            <input
              id="file-input"
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            {/* Show the selected image preview */}
            {/* {imageUrl && (
              <div>
                <img
                  src={imageUrl}
                  alt="Image Preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  }}
                />
              </div>
            )} */}

            {/* Show the uploaded image after it has been uploaded */}
          </div>
        </div>

        {/* Form */}
        <form>
          <label>
            Company Name <span style={{ color: "#cc4645" }}>*</span>
          </label>
          <input
            type="text"
            placeholder="LLC"
            value={formData.companyName}
            onChange={(e) => {
              const value = e.target.value;
              const capitalized =
                value.charAt(0).toUpperCase() + value.slice(1); // capitalize first letter
              handleChange({
                target: { name: "companyName", value: capitalized },
              });
            }}
            name="companyName"
          />

          <label>
            First Name <span style={{ color: "#cc4645" }}>*</span>
          </label>
          <input
            type="text"
            placeholder="John"
            value={formData.firstName}
            onChange={(e) => {
              const value = e.target.value;
              const capitalized =
                value.charAt(0).toUpperCase() + value.slice(1); // capitalize first letter
              handleChange({
                target: { name: "firstName", value: capitalized },
              });
            }}
            name="firstName"
          />

          <label>
            Last Name <span style={{ color: "#cc4645" }}>*</span>
          </label>
          <input
            type="text"
            placeholder="Doe"
            value={formData.lastName}
            onChange={(e) => {
              const value = e.target.value;
              const capitalized =
                value.charAt(0).toUpperCase() + value.slice(1); // capitalize first letter
              handleChange({
                target: { name: "lastName", value: capitalized },
              });
            }}
            name="lastName"
          />

          <label>
            Years in Business{" "}
            <span
            // style={{ color: "#737373" }}
            >
              (optional)
            </span>
          </label>

          <input
            type="number"
            placeholder="0"
            value={formData.yearsInBusiness}
            onChange={(e) => {
              const value = e.target.value;
              if (
                value === "" ||
                (/^\d+$/.test(value) && parseInt(value) <= 100)
              ) {
                handleChange({
                  target: { name: "yearsInBusiness", value: value },
                });
              }
            }}
            name="yearsInBusiness"
          />

          {/* <label>
            Company Founded Date{" "}
            <span style={{ color: "#a9a9a9" }}>(optional)</span>
          </label>
          <input
            type="date"
            value={formData.companyFoundedDate}
            onChange={handleChange}
            name="companyFoundedDate"
            max={new Date().toISOString().split("T")[0]}
          /> */}

          <label>
            Company Size
            <span style={{ color: "#cc4645" }}>*</span>
          </label>
          <select
            value={formData.companySize}
            onChange={handleChange}
            name="companySize"
          >
            <option>Small Team (1-9 employees)</option>
            <option>Medium Team (10-50 employees)</option>
            <option>Large Team (50+ employees)</option>
          </select>

          <label>Company Email Address</label>
          <input
            type="email"
            placeholder="example@email.com"
            value={formData.email}
            disabled={emailVerified}
            onChange={handleChange}
            name="email"
          />

          <p className="send-code-btn-2">
            <EmailOutlinedIcon />
            Email Verified
          </p>

          {/* Verification */}
          <div className="verification">
            <label className="mb-2">Company Phone Number</label>
            <div className="d-flex w-100 gap-3">
              <div className="country-selector-container" ref={dropdownRef}>
                <button
                  className="country-selector-trigger"
                  onClick={() => setIsOpen(!isOpen)}
                  type="button"
                  style={{ display: "flex", alignItems: "center", gap: 6 }}
                >
                  <ReactCountryFlag
                    countryCode={selected.country}
                    svg
                    style={{ width: "1.5em", height: "1.5em", marginRight: 4 }}
                  />
                  <span className="code-text">{selected.code}</span>
                  <svg
                    className={`chevron ${isOpen ? "open" : ""}`}
                    viewBox="0 0 24 24"
                    fill="none"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>

                {isOpen && (
                  <div className="dropdown">
                    <div className="search-container">
                      <input
                        type="text"
                        className="search-input"
                        placeholder="Search country..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        autoFocus
                      />
                    </div>

                    <div className="country-list">
                      {filteredCountries.length > 0 ? (
                        filteredCountries.map((country, index) => (
                          <div
                            key={`${country.country}-${index}`}
                            className={`country-item ${country.country === selected.country ? "selected" : ""}`}
                            onClick={() => handleSelect(country)}
                            style={{ display: "flex", alignItems: "center", gap: 8 }}
                          >
                            <ReactCountryFlag
                              countryCode={country.country}
                              svg
                              style={{ width: "1.5em", height: "1.5em", marginRight: 4 }}
                            />
                            <span className="country-name">{country.name}</span>
                            <span className="country-code">{country.code}</span>
                          </div>
                        ))
                      ) : (
                        <div className="no-results">
                          <div className="no-results-emoji">🔍</div>
                          <div>No countries found</div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <input
                  type="number"
                  placeholder="Mobile Number"
                  value={formData.mobileNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    if (value.length <= 10) {
                      setFormData((prev) => ({ ...prev, mobileNumber: value }));
                    }
                  }}
                  name="mobileNumber"
                  maxLength={10}
                  pattern="[0-9]"
                  style={{ borderRadius: "0 8px 8px 0" }}
                />
              </div>
            </div>
          </div>

          {emailVerified && (
            <>
              <label>
                ID Verification <span style={{ color: "#cc4645" }}>*</span>
              </label>
              <div className="password-input-profile mb-0">
                <div className="text-center">
                  <Person2OutlinedIcon />
                </div>
                <h5 className="text-center">Verify Your Identity</h5>
                <p className="text-center">
                  Complete secure ID verification with our trusted partner.
                </p>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <button
                    type="button"
                    className="start_verification-btn"
                    onClick={() => startVerification()}
                    style={{
                      fontWeight: "400",
                      width: "fit-content",
                      padding: "8px 24px",
                      borderRadius: "14px",
                    }}
                  >
                    <External style={{ width: "24px", height: "24px" }} />
                    Start Verification
                  </button>
                </div>
              </div>
              <p style={{ fontSize: 14, color: "#000" }}>
                By continuing, you consent to identity verification through our
                third-party provider.
              </p>
            </>
          )}

          {/* <div
            className="verification-box mt-0"
            style={{ border: "1px solid #bbf7d0" }}
          >
            <img src={Identityverification} alt="success" className="mt-1" />
            <div className="verification-box__content">
              {" "}
              <p
                className="verification-title"
                style={{ color: "#000", fontWeight: "700" }}
              >
                Identity verification
              </p>
              <p className="verification-text" style={{  fontWeight: "400" }}>
                Your identity has been verified successfully and is active on
                your profile.{" "}
              </p>
            </div>
          </div> */}

          {/* <div
            className="verification-box mt-0"
            style={{ background: "#f0f6ff", border: "1px solid #c7e0fe" }}
          >
            <img src={IDVerificationProgress} alt="success" className="mt-1" />
            <div className="verification-box__content">
              <p
                className="verification-title"
                style={{
                  color: "#1f3a89",
                  fontWeight: "700",
                }}
              >
                {" "}
                ID Verification In Progress
              </p>
              <p
                className="verification-text"
                style={{
                  color: "#1f3a89",
                  fontWeight: "400",
                }}
              >
                We are reviewing your ID in the background. You can browse the
                app, but all actions will be available once verification is
                complete.
              </p>
            </div>
          </div> */}

          {/* <div
            className="verification-box mt-0"
            style={{ backgroundColor: "#fef1f2", border: "1px solid #bc5a59" }}
          >
            <img src={VerificationFailed} alt="success" className="mt-1" />
            <div className="verification-box__content">
              <p
                className="verification-title"
                style={{
                  background:
                    "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: "700",
                }}
              >
                Verification Failed
              </p>
              <p
                className="verification-text"
                style={{
                  background:
                    "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  fontWeight: "400",
                }}
              >
                We couldn’t verify your ID. Please try again to access all
                available features.
              </p>
              <button
                type="submit"
                className="next-btn w-80 "
                style={{
                  background:
                    "linear-gradient(90deg, #cc4645 0%, #9a1d1c 100%)",
                  fontWeight: "400",
                  padding: "6px 30px",
                  borderRadius: "14px",
                }}
              >
                <img
                  src={RetryVerification}
                  alt="success"
                  className="me-1 mb-1"
                />
                Retry Verification
              </button>
            </div>
          </div> */}

          <button
            type="submit"
            className="next-btn"
            onClick={e => {
              if (!emailVerified) {
                e.preventDefault();
                e.stopPropagation();
                return;
              }
              else {
                submitFirstStep(e);
              }
            }}
            disabled={!emailVerified}
            style={{
              background: emailVerified ? "#b22222" : "#b3b3b3",
              cursor: emailVerified ? "pointer" : "not-allowed",
            }}
          >
            Next → 
          </button>
        </form>
      </div>
    </div>
  );
};

export default SignUpStepOne;
